import { Module, ActionContext } from 'vuex';
import { ajax } from '@/util/ajax';

const URL = {
  PAGE: '/dh-datamaint/suitPeople/listAll',
  ADD: '/dh-datamaint/suitPeople/add',
  DELETE: '/dh-datamaint/suitPeople/delete',
  DETAIL: '/dh-datamaint/suitPeople/getById',
  UPDATE: '/dh-datamaint/suitPeople/update',
  GET_SORT: '/dh-datamaint/suitPeople/count',
  SORT: '/dh-datamaint/suitPeople/sort',
  LIST: '/dh-datamaint/suitPeople/listAll'
};

class SuitModule implements Module<any, any> {
  namespaced = true;

  state = {};

  mutations = {};

  actions = {
    async getPage(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.PAGE, { params: payload.data });
    },

    async getDetail(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.DETAIL, { params: payload.data });
    },

    async Add(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.ADD, payload.data);
    },

    async Update(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.UPDATE, payload.data);
    },

    async getSort(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.GET_SORT, { params: payload.data });
    },

    async Sort(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.SORT, payload.data);
    },

    async Delete(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.DELETE, null, { params: payload.data });
    },

    async getSuitList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.LIST, { params: payload.data });
    }
  };
}

export const suitModule = new SuitModule();
